import { flow } from 'lodash';

import { NAME } from './reports.constant';

const selectStateKey = (state) => state[NAME];

export const selectState = flow(selectStateKey);
